import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { PlatformContainer } from 'reusable/containers/PlatformContainer'
import { useAuthStore } from './AuthStore'
import useStore from 'reusable/mobx-store-utils'
import { OAuthRedirectStore } from './OAuthRedirectStore'
import Typography from '@mui/material/Typography'

/**
 * Handles OAuth redirects from external providers (like Circle)
 * Shows loading screen while processing the OAuth flow
 */
export const OAuthRedirect = observer(() => {
   const [searchParams] = useSearchParams()
   const navigate = useNavigate()
   const authStore = useAuthStore()
   const oauthStore = useStore(() => new OAuthRedirectStore({ authStore }))

   useEffect(() => {
      oauthStore.handleOAuthRedirect(searchParams, navigate)
   }, [searchParams, authStore.isAuthenticated, navigate, oauthStore])

   return (
      <PlatformContainer
         loading={!oauthStore.showError}
         loadingMessage={oauthStore.loadingMessage}
         contentCentered
      >
         {oauthStore.showError && (
            <>
               <Typography variant="h5" component="h3" gutterBottom sx={{ textAlign: 'center' }}>
                  Unable to complete sign in
               </Typography>
               <Typography variant="body1" gutterBottom sx={{ textAlign: 'center' }}>
                  {oauthStore.message}
               </Typography>
               <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                  Redirecting to home page...
               </Typography>
            </>
         )}
      </PlatformContainer>
   )
})
